export default {
    viewAttendance: 'สถานะเข้างาน',
    profile: 'ข้อมูลส่วนตัว',
    employeeId: 'รหัสพนักงาน',
    employeeFullname: 'ชื่อ - นามสกุล',
    email: 'อีเมล์',
    position: 'ตำแหน่ง',
    bureau: 'สำนักงาน / หน่วยงาน',
    attendanceDetail: 'รายละเอียดลงเวลา',
    date: 'วันที่',
    time: 'เวลา',
    method: 'วิธีลงเวลา',
    temperature: 'อุณหภูมิ',
    location: 'สถานที่',
    attachment: 'เอกสารแนบ',
    thereIsNoPunchLog: 'ยังไม่ได้ลงเวลา'
}
